import { render, staticRenderFns } from "./BlocksComponent.vue?vue&type=template&id=100c7c10&scoped=true&"
import script from "./BlocksComponent.vue?vue&type=script&lang=js&"
export * from "./BlocksComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlocksComponent.vue?vue&type=style&index=0&id=100c7c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c7c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100c7c10')) {
      api.createRecord('100c7c10', component.options)
    } else {
      api.reload('100c7c10', component.options)
    }
    module.hot.accept("./BlocksComponent.vue?vue&type=template&id=100c7c10&scoped=true&", function () {
      api.rerender('100c7c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/BlocksComponent.vue"
export default component.exports